let zIndex = 999;
export const getIndex = () => zIndex++;